// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';
import type { IPaymentMethodConfigDto } from './IPaymentMethodConfigDto';
import {
    IPaymentMethodConfigDtoFromJSON,
    IPaymentMethodConfigDtoFromJSONTyped,
    IPaymentMethodConfigDtoToJSON,
    IPaymentMethodConfigDtoToJSONTyped,
} from './IPaymentMethodConfigDto';

/**
 * 
 * @export
 * @interface IOverridablePropertiesInfoDto
 */
export interface IOverridablePropertiesInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    account_lockout_time?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    id_source_id?: IOverridablePropertiesInfoDtoIdSourceIdEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    customer_service_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    customer_service_url_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    customer_service_url_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    customer_service_email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    customer_service_is_enabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    hsa_custodian_id?: IOverridablePropertiesInfoDtoHsaCustodianIdEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    sso_only?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    logo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    electronic_funding_mode_id?: IOverridablePropertiesInfoDtoElectronicFundingModeIdEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    partner_mobile_app?: IOverridablePropertiesInfoDtoPartnerMobileAppEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    partner_app_ios_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    partner_app_android_link?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    mobile_app_theme_id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    check_funding_model?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_offered?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    allow_dependent_card?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    bin_setup?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    prin_setup?: string | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOverridablePropertiesInfoDto
     */
    communication_channels?: Set<IOverridablePropertiesInfoDtoCommunicationChannelsEnum> | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOverridablePropertiesInfoDto
     */
    organization_communication_categories?: Set<IOverridablePropertiesInfoDtoOrganizationCommunicationCategoriesEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_processor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    external_administrator_fees_account_method?: IOverridablePropertiesInfoDtoExternalAdministratorFeesAccountMethodEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    external_payroll_contributions_account_method?: IOverridablePropertiesInfoDtoExternalPayrollContributionsAccountMethodEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    external_replenishment_account_method?: IOverridablePropertiesInfoDtoExternalReplenishmentAccountMethodEnum | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    root_external_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    outgoing_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_settlement_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    interest_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    elevate_interest_source_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    fee_card_interchange_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    payroll_contributions_hold_period?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    ee_contributions_hold_period?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_phone_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_employer_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    replenishment_frequency_type?: IOverridablePropertiesInfoDtoReplenishmentFrequencyTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    replenishment_day_number?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_reimbursement_allowed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_bill_pay_allowed?: boolean | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOverridablePropertiesInfoDto
     * @deprecated
     */
    allowed_payment_methods?: Set<IOverridablePropertiesInfoDtoAllowedPaymentMethodsEnum> | null;
    /**
     * 
     * @type {Array<IPaymentMethodConfigDto>}
     * @memberof IOverridablePropertiesInfoDto
     */
    allowed_payment_method_configs?: Array<IPaymentMethodConfigDto>;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    session_timeout_warn?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    session_timeout_logout?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    prefund_replenishment_percent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    prefund_replenishment_min_value?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    prefund_replenishment_creep_percent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    prefund_replenishment_creep_min?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_file_manager_access_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_file_auto_post_enabled?: boolean | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOverridablePropertiesInfoDto
     */
    allowed_file_types?: Set<IOverridablePropertiesInfoDtoAllowedFileTypesEnum> | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOverridablePropertiesInfoDto
     */
    duplicate_check_file_types?: Set<IOverridablePropertiesInfoDtoDuplicateCheckFileTypesEnum> | null;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IOverridablePropertiesInfoDto
     */
    logo_info?: IOrganizationLogoDto;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    minimum_payment_reimbursement_amount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    waiting_for_funds_continue_payment?: IOverridablePropertiesInfoDtoWaitingForFundsContinuePaymentEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    ai_adjudication?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    ai_confidence_level?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    email_domain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    email_logo_type?: IOverridablePropertiesInfoDtoEmailLogoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    email_logo_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    privacy_policy_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    terms_and_conditions_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    about_us_link?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    email_theme?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    statement_type?: IOverridablePropertiesInfoDtoStatementTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    statement_frequency_type?: IOverridablePropertiesInfoDtoStatementFrequencyTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    email_illustration_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    number_of_days_before_plan_start?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_default_link?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    claims_assignment_number?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof IOverridablePropertiesInfoDto
     */
    prefund_initial_delay_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IOverridablePropertiesInfoDto
     */
    card_processing_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    reservation_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    admin_portal_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    participant_portal_link?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_external_link?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    external_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    pricing_consent?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_organization_orphan?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    orphan_organization_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    orphan_start_timing_days?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    waiting_for_funds_expiration?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    file_location?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    allow_manual_contribution?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    allow_scheduled_contribution?: IOverridablePropertiesInfoDtoAllowScheduledContributionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    custom_reporting_field_1_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    custom_reporting_field_2_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    custom_reporting_field_3_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    custom_reporting_field_4_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    custom_reporting_field_5_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_custom_reporting_field_1_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_custom_reporting_field_2_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_custom_reporting_field_3_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_custom_reporting_field_4_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_custom_reporting_field_5_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    allow_employees_to_edit_address?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_claim_offsets_allowed?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    claim_offset_logic?: IOverridablePropertiesInfoDtoClaimOffsetLogicEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    allow_prefund?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    contribution_push_give_up_days?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    require_participant_mfa?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    require_admin_mfa?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    paper_statement_fees_paid_by?: IOverridablePropertiesInfoDtoPaperStatementFeesPaidByEnum | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    paper_statement_fees_amount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    admin_chatbot_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    participant_chatbot_link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    allow_renewals?: IOverridablePropertiesInfoDtoAllowRenewalsEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    working_hours?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    substantiation_rate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    recurring_card_swipes?: IOverridablePropertiesInfoDtoRecurringCardSwipesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    admin_sso_only?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    push_provisioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    automated_org_lock_enabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    is_sigis_auto_approve_enabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    external_balance_adjustment_account_method?: IOverridablePropertiesInfoDtoExternalBalanceAdjustmentAccountMethodEnum | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    balance_adjustment_hold_period?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    balance_adjustment_push_give_up_days?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    documents_needed_reminder?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    documents_needed_reminder_days?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    suspend_card?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    suspend_card_days?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    suspension_threshold?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    suspension_threshold_amount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    fraud_single_claim_threshold?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    fraud_single_claim_threshold_amount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    fraud_daily_threshold?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    fraud_daily_threshold_amount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    fraud_weekly_threshold?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    fraud_weekly_threshold_amount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOverridablePropertiesInfoDto
     */
    depository_bank_config_type?: IOverridablePropertiesInfoDtoDepositoryBankConfigTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOverridablePropertiesInfoDto
     */
    zendesk_sso_enabled?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    days_to_pend_returned_checks?: number;
    /**
     * 
     * @type {number}
     * @memberof IOverridablePropertiesInfoDto
     */
    hsa_custodian_config_id?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoIdSourceIdEnum {
    SSN = 'SSN',
    EMPLOYER_EMPLOYEE_ID = 'EMPLOYER_EMPLOYEE_ID',
    PARTNER_EMPLOYEE_ID = 'PARTNER_EMPLOYEE_ID'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoHsaCustodianIdEnum {
    UMB = 'UMB',
    NONE = 'NONE'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoElectronicFundingModeIdEnum {
    PARTNER_FUNDED = 'PARTNER_FUNDED',
    EMPLOYER_FUNDED = 'EMPLOYER_FUNDED',
    HIERARCHY_FUNDED = 'HIERARCHY_FUNDED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoPartnerMobileAppEnum {
    NONE = 'NONE',
    ELEVATE_APP = 'ELEVATE_APP',
    PARTNER_OWN_APP = 'PARTNER_OWN_APP'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoCommunicationChannelsEnum {
    NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
    EMAIL_SMS = 'EMAIL_SMS',
    DATA_EXPORT = 'DATA_EXPORT'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoOrganizationCommunicationCategoriesEnum {
    WELCOME = 'WELCOME',
    ENROLLMENT_UPDATES = 'ENROLLMENT_UPDATES',
    HSA = 'HSA',
    INVESTMENTS = 'INVESTMENTS',
    REMINDERS = 'REMINDERS',
    CAMPAIGNS = 'CAMPAIGNS',
    CARD_STATUS = 'CARD_STATUS',
    PROFILE_UPDATES = 'PROFILE_UPDATES',
    ACCOUNT_ACTIVITY = 'ACCOUNT_ACTIVITY',
    ENROLLMENTS = 'ENROLLMENTS',
    INVOICE = 'INVOICE',
    TAX_FORMS = 'TAX_FORMS',
    FINANCE = 'FINANCE'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoExternalAdministratorFeesAccountMethodEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoExternalPayrollContributionsAccountMethodEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoExternalReplenishmentAccountMethodEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoReplenishmentFrequencyTypeEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoAllowedPaymentMethodsEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoAllowedFileTypesEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoDuplicateCheckFileTypesEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoWaitingForFundsContinuePaymentEnum {
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE',
    AUTO_PAY = 'AUTO_PAY'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoEmailLogoTypeEnum {
    ELEVATE = 'ELEVATE',
    ORGANIZATION_BRANDING = 'ORGANIZATION_BRANDING',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoStatementTypeEnum {
    PAPER_AND_ELECTRONIC = 'PAPER_AND_ELECTRONIC',
    ELECTRONIC_ONLY = 'ELECTRONIC_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoStatementFrequencyTypeEnum {
    QUARTERLY = 'QUARTERLY',
    MONTHLY = 'MONTHLY'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoAllowScheduledContributionEnum {
    ALLOWED_WITH_AUTO_APPROVAL = 'ALLOWED_WITH_AUTO_APPROVAL',
    ALLOWED_WITH_MANUAL_APPROVAL = 'ALLOWED_WITH_MANUAL_APPROVAL',
    DISABLED = 'DISABLED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoClaimOffsetLogicEnum {
    PAY_FROM_ANY_ACCOUNT = 'PAY_FROM_ANY_ACCOUNT',
    PAY_FROM_SAME_ACCOUNT = 'PAY_FROM_SAME_ACCOUNT'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoPaperStatementFeesPaidByEnum {
    PARTICIPANT = 'PARTICIPANT',
    ADMIN = 'ADMIN'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoAllowRenewalsEnum {
    NO_RENEWALS = 'NO_RENEWALS',
    BY_REQUEST = 'BY_REQUEST'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoRecurringCardSwipesEnum {
    NO_AUTO_APPROVAL = 'NO_AUTO_APPROVAL',
    AUTO_APPROVE_ALL_MATCHES = 'AUTO_APPROVE_ALL_MATCHES',
    AUTO_APPROVE_WITHIN_PLAN_YEAR = 'AUTO_APPROVE_WITHIN_PLAN_YEAR'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoExternalBalanceAdjustmentAccountMethodEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}
/**
* @export
* @enum {string}
*/
export enum IOverridablePropertiesInfoDtoDepositoryBankConfigTypeEnum {
    UMB_DEPOSITORY_CONFIG = 'UMB_DEPOSITORY_CONFIG',
    EMPRISE_DEPOSITORY_CONFIG = 'EMPRISE_DEPOSITORY_CONFIG',
    EMPRISE_OMNIBUSES_UMB_CLEARING_DEPOSITORY_CONFIG = 'EMPRISE_OMNIBUSES_UMB_CLEARING_DEPOSITORY_CONFIG'
}


/**
 * Check if a given object implements the IOverridablePropertiesInfoDto interface.
 */
export function instanceOfIOverridablePropertiesInfoDto(value: object): value is IOverridablePropertiesInfoDto {
    return true;
}

export function IOverridablePropertiesInfoDtoFromJSON(json: any): IOverridablePropertiesInfoDto {
    return IOverridablePropertiesInfoDtoFromJSONTyped(json, false);
}

export function IOverridablePropertiesInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOverridablePropertiesInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_lockout_time': json['account_lockout_time'] == null ? undefined : json['account_lockout_time'],
        'id_source_id': json['id_source_id'] == null ? undefined : json['id_source_id'],
        'customer_service_number': json['customer_service_number'] == null ? undefined : json['customer_service_number'],
        'customer_service_url_name': json['customer_service_url_name'] == null ? undefined : json['customer_service_url_name'],
        'customer_service_url_link': json['customer_service_url_link'] == null ? undefined : json['customer_service_url_link'],
        'customer_service_email': json['customer_service_email'] == null ? undefined : json['customer_service_email'],
        'customer_service_is_enabled': json['customer_service_is_enabled'] == null ? undefined : json['customer_service_is_enabled'],
        'hsa_custodian_id': json['hsa_custodian_id'] == null ? undefined : json['hsa_custodian_id'],
        'sso_only': json['sso_only'] == null ? undefined : json['sso_only'],
        'url': json['url'] == null ? undefined : json['url'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'electronic_funding_mode_id': json['electronic_funding_mode_id'] == null ? undefined : json['electronic_funding_mode_id'],
        'partner_mobile_app': json['partner_mobile_app'] == null ? undefined : json['partner_mobile_app'],
        'partner_app_ios_link': json['partner_app_ios_link'] == null ? undefined : json['partner_app_ios_link'],
        'partner_app_android_link': json['partner_app_android_link'] == null ? undefined : json['partner_app_android_link'],
        'mobile_app_theme_id': json['mobile_app_theme_id'] == null ? undefined : json['mobile_app_theme_id'],
        'check_funding_model': json['check_funding_model'] == null ? undefined : json['check_funding_model'],
        'card_offered': json['card_offered'] == null ? undefined : json['card_offered'],
        'allow_dependent_card': json['allow_dependent_card'] == null ? undefined : json['allow_dependent_card'],
        'bin_setup': json['bin_setup'] == null ? undefined : json['bin_setup'],
        'prin_setup': json['prin_setup'] == null ? undefined : json['prin_setup'],
        'communication_channels': json['communication_channels'] == null ? undefined : new Set(json['communication_channels']),
        'organization_communication_categories': json['organization_communication_categories'] == null ? undefined : new Set(json['organization_communication_categories']),
        'card_processor': json['card_processor'] == null ? undefined : json['card_processor'],
        'external_administrator_fees_account_method': json['external_administrator_fees_account_method'] == null ? undefined : json['external_administrator_fees_account_method'],
        'external_payroll_contributions_account_method': json['external_payroll_contributions_account_method'] == null ? undefined : json['external_payroll_contributions_account_method'],
        'external_replenishment_account_method': json['external_replenishment_account_method'] == null ? undefined : json['external_replenishment_account_method'],
        'root_external_account': json['root_external_account'] == null ? undefined : json['root_external_account'],
        'outgoing_clearing_account': json['outgoing_clearing_account'] == null ? undefined : json['outgoing_clearing_account'],
        'card_settlement_clearing_account': json['card_settlement_clearing_account'] == null ? undefined : json['card_settlement_clearing_account'],
        'interest_clearing_account': json['interest_clearing_account'] == null ? undefined : json['interest_clearing_account'],
        'elevate_interest_source_account': json['elevate_interest_source_account'] == null ? undefined : json['elevate_interest_source_account'],
        'fee_card_interchange_account': json['fee_card_interchange_account'] == null ? undefined : json['fee_card_interchange_account'],
        'payroll_contributions_hold_period': json['payroll_contributions_hold_period'] == null ? undefined : json['payroll_contributions_hold_period'],
        'ee_contributions_hold_period': json['ee_contributions_hold_period'] == null ? undefined : json['ee_contributions_hold_period'],
        'card_phone_number': json['card_phone_number'] == null ? undefined : json['card_phone_number'],
        'card_url': json['card_url'] == null ? undefined : json['card_url'],
        'card_employer_name': json['card_employer_name'] == null ? undefined : json['card_employer_name'],
        'replenishment_frequency_type': json['replenishment_frequency_type'] == null ? undefined : json['replenishment_frequency_type'],
        'replenishment_day_number': json['replenishment_day_number'] == null ? undefined : json['replenishment_day_number'],
        'is_reimbursement_allowed': json['is_reimbursement_allowed'] == null ? undefined : json['is_reimbursement_allowed'],
        'is_bill_pay_allowed': json['is_bill_pay_allowed'] == null ? undefined : json['is_bill_pay_allowed'],
        'allowed_payment_methods': json['allowed_payment_methods'] == null ? undefined : new Set(json['allowed_payment_methods']),
        'allowed_payment_method_configs': json['allowed_payment_method_configs'] == null ? undefined : ((json['allowed_payment_method_configs'] as Array<any>).map(IPaymentMethodConfigDtoFromJSON)),
        'session_timeout_warn': json['session_timeout_warn'] == null ? undefined : json['session_timeout_warn'],
        'session_timeout_logout': json['session_timeout_logout'] == null ? undefined : json['session_timeout_logout'],
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : json['prefund_replenishment_percent'],
        'prefund_replenishment_min_value': json['prefund_replenishment_min_value'] == null ? undefined : json['prefund_replenishment_min_value'],
        'prefund_replenishment_creep_percent': json['prefund_replenishment_creep_percent'] == null ? undefined : json['prefund_replenishment_creep_percent'],
        'prefund_replenishment_creep_min': json['prefund_replenishment_creep_min'] == null ? undefined : json['prefund_replenishment_creep_min'],
        'is_file_manager_access_enabled': json['is_file_manager_access_enabled'] == null ? undefined : json['is_file_manager_access_enabled'],
        'is_file_auto_post_enabled': json['is_file_auto_post_enabled'] == null ? undefined : json['is_file_auto_post_enabled'],
        'allowed_file_types': json['allowed_file_types'] == null ? undefined : new Set(json['allowed_file_types']),
        'duplicate_check_file_types': json['duplicate_check_file_types'] == null ? undefined : new Set(json['duplicate_check_file_types']),
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
        'minimum_payment_reimbursement_amount': json['minimum_payment_reimbursement_amount'] == null ? undefined : json['minimum_payment_reimbursement_amount'],
        'waiting_for_funds_continue_payment': json['waiting_for_funds_continue_payment'] == null ? undefined : json['waiting_for_funds_continue_payment'],
        'ai_adjudication': json['ai_adjudication'] == null ? undefined : json['ai_adjudication'],
        'ai_confidence_level': json['ai_confidence_level'] == null ? undefined : json['ai_confidence_level'],
        'email_domain': json['email_domain'] == null ? undefined : json['email_domain'],
        'email_logo_type': json['email_logo_type'] == null ? undefined : json['email_logo_type'],
        'email_logo_path': json['email_logo_path'] == null ? undefined : json['email_logo_path'],
        'privacy_policy_link': json['privacy_policy_link'] == null ? undefined : json['privacy_policy_link'],
        'terms_and_conditions_link': json['terms_and_conditions_link'] == null ? undefined : json['terms_and_conditions_link'],
        'about_us_link': json['about_us_link'] == null ? undefined : json['about_us_link'],
        'email_theme': json['email_theme'] == null ? undefined : json['email_theme'],
        'statement_type': json['statement_type'] == null ? undefined : json['statement_type'],
        'statement_frequency_type': json['statement_frequency_type'] == null ? undefined : json['statement_frequency_type'],
        'email_illustration_id': json['email_illustration_id'] == null ? undefined : json['email_illustration_id'],
        'number_of_days_before_plan_start': json['number_of_days_before_plan_start'] == null ? undefined : json['number_of_days_before_plan_start'],
        'is_default_link': json['is_default_link'] == null ? undefined : json['is_default_link'],
        'claims_assignment_number': json['claims_assignment_number'] == null ? undefined : json['claims_assignment_number'],
        'prefund_initial_delay_date': json['prefund_initial_delay_date'] == null ? undefined : (new Date(json['prefund_initial_delay_date'])),
        'card_processing_start_date': json['card_processing_start_date'] == null ? undefined : (new Date(json['card_processing_start_date'])),
        'reservation_code': json['reservation_code'] == null ? undefined : json['reservation_code'],
        'admin_portal_link': json['admin_portal_link'] == null ? undefined : json['admin_portal_link'],
        'participant_portal_link': json['participant_portal_link'] == null ? undefined : json['participant_portal_link'],
        'is_external_link': json['is_external_link'] == null ? undefined : json['is_external_link'],
        'external_link': json['external_link'] == null ? undefined : json['external_link'],
        'pricing_consent': json['pricing_consent'] == null ? undefined : json['pricing_consent'],
        'is_organization_orphan': json['is_organization_orphan'] == null ? undefined : json['is_organization_orphan'],
        'orphan_organization_id': json['orphan_organization_id'] == null ? undefined : json['orphan_organization_id'],
        'orphan_start_timing_days': json['orphan_start_timing_days'] == null ? undefined : json['orphan_start_timing_days'],
        'waiting_for_funds_expiration': json['waiting_for_funds_expiration'] == null ? undefined : json['waiting_for_funds_expiration'],
        'file_location': json['file_location'] == null ? undefined : json['file_location'],
        'allow_manual_contribution': json['allow_manual_contribution'] == null ? undefined : json['allow_manual_contribution'],
        'allow_scheduled_contribution': json['allow_scheduled_contribution'] == null ? undefined : json['allow_scheduled_contribution'],
        'custom_reporting_field_1_name': json['custom_reporting_field_1_name'] == null ? undefined : json['custom_reporting_field_1_name'],
        'custom_reporting_field_2_name': json['custom_reporting_field_2_name'] == null ? undefined : json['custom_reporting_field_2_name'],
        'custom_reporting_field_3_name': json['custom_reporting_field_3_name'] == null ? undefined : json['custom_reporting_field_3_name'],
        'custom_reporting_field_4_name': json['custom_reporting_field_4_name'] == null ? undefined : json['custom_reporting_field_4_name'],
        'custom_reporting_field_5_name': json['custom_reporting_field_5_name'] == null ? undefined : json['custom_reporting_field_5_name'],
        'is_custom_reporting_field_1_enabled': json['is_custom_reporting_field_1_enabled'] == null ? undefined : json['is_custom_reporting_field_1_enabled'],
        'is_custom_reporting_field_2_enabled': json['is_custom_reporting_field_2_enabled'] == null ? undefined : json['is_custom_reporting_field_2_enabled'],
        'is_custom_reporting_field_3_enabled': json['is_custom_reporting_field_3_enabled'] == null ? undefined : json['is_custom_reporting_field_3_enabled'],
        'is_custom_reporting_field_4_enabled': json['is_custom_reporting_field_4_enabled'] == null ? undefined : json['is_custom_reporting_field_4_enabled'],
        'is_custom_reporting_field_5_enabled': json['is_custom_reporting_field_5_enabled'] == null ? undefined : json['is_custom_reporting_field_5_enabled'],
        'allow_employees_to_edit_address': json['allow_employees_to_edit_address'] == null ? undefined : json['allow_employees_to_edit_address'],
        'is_claim_offsets_allowed': json['is_claim_offsets_allowed'] == null ? undefined : json['is_claim_offsets_allowed'],
        'claim_offset_logic': json['claim_offset_logic'] == null ? undefined : json['claim_offset_logic'],
        'allow_prefund': json['allow_prefund'] == null ? undefined : json['allow_prefund'],
        'contribution_push_give_up_days': json['contribution_push_give_up_days'] == null ? undefined : json['contribution_push_give_up_days'],
        'require_participant_mfa': json['require_participant_mfa'] == null ? undefined : json['require_participant_mfa'],
        'require_admin_mfa': json['require_admin_mfa'] == null ? undefined : json['require_admin_mfa'],
        'paper_statement_fees_paid_by': json['paper_statement_fees_paid_by'] == null ? undefined : json['paper_statement_fees_paid_by'],
        'paper_statement_fees_amount': json['paper_statement_fees_amount'] == null ? undefined : json['paper_statement_fees_amount'],
        'admin_chatbot_link': json['admin_chatbot_link'] == null ? undefined : json['admin_chatbot_link'],
        'participant_chatbot_link': json['participant_chatbot_link'] == null ? undefined : json['participant_chatbot_link'],
        'allow_renewals': json['allow_renewals'] == null ? undefined : json['allow_renewals'],
        'working_hours': json['working_hours'] == null ? undefined : json['working_hours'],
        'substantiation_rate': json['substantiation_rate'] == null ? undefined : json['substantiation_rate'],
        'recurring_card_swipes': json['recurring_card_swipes'] == null ? undefined : json['recurring_card_swipes'],
        'admin_sso_only': json['admin_sso_only'] == null ? undefined : json['admin_sso_only'],
        'push_provisioning': json['push_provisioning'] == null ? undefined : json['push_provisioning'],
        'automated_org_lock_enabled': json['automated_org_lock_enabled'] == null ? undefined : json['automated_org_lock_enabled'],
        'is_sigis_auto_approve_enabled': json['is_sigis_auto_approve_enabled'] == null ? undefined : json['is_sigis_auto_approve_enabled'],
        'external_balance_adjustment_account_method': json['external_balance_adjustment_account_method'] == null ? undefined : json['external_balance_adjustment_account_method'],
        'balance_adjustment_hold_period': json['balance_adjustment_hold_period'] == null ? undefined : json['balance_adjustment_hold_period'],
        'balance_adjustment_push_give_up_days': json['balance_adjustment_push_give_up_days'] == null ? undefined : json['balance_adjustment_push_give_up_days'],
        'documents_needed_reminder': json['documents_needed_reminder'] == null ? undefined : json['documents_needed_reminder'],
        'documents_needed_reminder_days': json['documents_needed_reminder_days'] == null ? undefined : json['documents_needed_reminder_days'],
        'suspend_card': json['suspend_card'] == null ? undefined : json['suspend_card'],
        'suspend_card_days': json['suspend_card_days'] == null ? undefined : json['suspend_card_days'],
        'suspension_threshold': json['suspension_threshold'] == null ? undefined : json['suspension_threshold'],
        'suspension_threshold_amount': json['suspension_threshold_amount'] == null ? undefined : json['suspension_threshold_amount'],
        'fraud_single_claim_threshold': json['fraud_single_claim_threshold'] == null ? undefined : json['fraud_single_claim_threshold'],
        'fraud_single_claim_threshold_amount': json['fraud_single_claim_threshold_amount'] == null ? undefined : json['fraud_single_claim_threshold_amount'],
        'fraud_daily_threshold': json['fraud_daily_threshold'] == null ? undefined : json['fraud_daily_threshold'],
        'fraud_daily_threshold_amount': json['fraud_daily_threshold_amount'] == null ? undefined : json['fraud_daily_threshold_amount'],
        'fraud_weekly_threshold': json['fraud_weekly_threshold'] == null ? undefined : json['fraud_weekly_threshold'],
        'fraud_weekly_threshold_amount': json['fraud_weekly_threshold_amount'] == null ? undefined : json['fraud_weekly_threshold_amount'],
        'depository_bank_config_type': json['depository_bank_config_type'] == null ? undefined : json['depository_bank_config_type'],
        'zendesk_sso_enabled': json['zendesk_sso_enabled'] == null ? undefined : json['zendesk_sso_enabled'],
        'days_to_pend_returned_checks': json['days_to_pend_returned_checks'] == null ? undefined : json['days_to_pend_returned_checks'],
        'hsa_custodian_config_id': json['hsa_custodian_config_id'] == null ? undefined : json['hsa_custodian_config_id'],
    };
}

export function IOverridablePropertiesInfoDtoToJSON(json: any): IOverridablePropertiesInfoDto {
    return IOverridablePropertiesInfoDtoToJSONTyped(json, false);
}

export function IOverridablePropertiesInfoDtoToJSONTyped(value?: IOverridablePropertiesInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_lockout_time': value['account_lockout_time'],
        'id_source_id': value['id_source_id'],
        'customer_service_number': value['customer_service_number'],
        'customer_service_url_name': value['customer_service_url_name'],
        'customer_service_url_link': value['customer_service_url_link'],
        'customer_service_email': value['customer_service_email'],
        'customer_service_is_enabled': value['customer_service_is_enabled'],
        'hsa_custodian_id': value['hsa_custodian_id'],
        'sso_only': value['sso_only'],
        'url': value['url'],
        'logo': value['logo'],
        'electronic_funding_mode_id': value['electronic_funding_mode_id'],
        'partner_mobile_app': value['partner_mobile_app'],
        'partner_app_ios_link': value['partner_app_ios_link'],
        'partner_app_android_link': value['partner_app_android_link'],
        'mobile_app_theme_id': value['mobile_app_theme_id'],
        'check_funding_model': value['check_funding_model'],
        'card_offered': value['card_offered'],
        'allow_dependent_card': value['allow_dependent_card'],
        'bin_setup': value['bin_setup'],
        'prin_setup': value['prin_setup'],
        'communication_channels': value['communication_channels'] == null ? undefined : Array.from(value['communication_channels'] as Set<any>),
        'organization_communication_categories': value['organization_communication_categories'] == null ? undefined : Array.from(value['organization_communication_categories'] as Set<any>),
        'card_processor': value['card_processor'],
        'external_administrator_fees_account_method': value['external_administrator_fees_account_method'],
        'external_payroll_contributions_account_method': value['external_payroll_contributions_account_method'],
        'external_replenishment_account_method': value['external_replenishment_account_method'],
        'root_external_account': value['root_external_account'],
        'outgoing_clearing_account': value['outgoing_clearing_account'],
        'card_settlement_clearing_account': value['card_settlement_clearing_account'],
        'interest_clearing_account': value['interest_clearing_account'],
        'elevate_interest_source_account': value['elevate_interest_source_account'],
        'fee_card_interchange_account': value['fee_card_interchange_account'],
        'payroll_contributions_hold_period': value['payroll_contributions_hold_period'],
        'ee_contributions_hold_period': value['ee_contributions_hold_period'],
        'card_phone_number': value['card_phone_number'],
        'card_url': value['card_url'],
        'card_employer_name': value['card_employer_name'],
        'replenishment_frequency_type': value['replenishment_frequency_type'],
        'replenishment_day_number': value['replenishment_day_number'],
        'is_reimbursement_allowed': value['is_reimbursement_allowed'],
        'is_bill_pay_allowed': value['is_bill_pay_allowed'],
        'allowed_payment_methods': value['allowed_payment_methods'] == null ? undefined : Array.from(value['allowed_payment_methods'] as Set<any>),
        'allowed_payment_method_configs': value['allowed_payment_method_configs'] == null ? undefined : ((value['allowed_payment_method_configs'] as Array<any>).map(IPaymentMethodConfigDtoToJSON)),
        'session_timeout_warn': value['session_timeout_warn'],
        'session_timeout_logout': value['session_timeout_logout'],
        'prefund_replenishment_percent': value['prefund_replenishment_percent'],
        'prefund_replenishment_min_value': value['prefund_replenishment_min_value'],
        'prefund_replenishment_creep_percent': value['prefund_replenishment_creep_percent'],
        'prefund_replenishment_creep_min': value['prefund_replenishment_creep_min'],
        'is_file_manager_access_enabled': value['is_file_manager_access_enabled'],
        'is_file_auto_post_enabled': value['is_file_auto_post_enabled'],
        'allowed_file_types': value['allowed_file_types'] == null ? undefined : Array.from(value['allowed_file_types'] as Set<any>),
        'duplicate_check_file_types': value['duplicate_check_file_types'] == null ? undefined : Array.from(value['duplicate_check_file_types'] as Set<any>),
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
        'minimum_payment_reimbursement_amount': value['minimum_payment_reimbursement_amount'],
        'waiting_for_funds_continue_payment': value['waiting_for_funds_continue_payment'],
        'ai_adjudication': value['ai_adjudication'],
        'ai_confidence_level': value['ai_confidence_level'],
        'email_domain': value['email_domain'],
        'email_logo_type': value['email_logo_type'],
        'email_logo_path': value['email_logo_path'],
        'privacy_policy_link': value['privacy_policy_link'],
        'terms_and_conditions_link': value['terms_and_conditions_link'],
        'about_us_link': value['about_us_link'],
        'email_theme': value['email_theme'],
        'statement_type': value['statement_type'],
        'statement_frequency_type': value['statement_frequency_type'],
        'email_illustration_id': value['email_illustration_id'],
        'number_of_days_before_plan_start': value['number_of_days_before_plan_start'],
        'is_default_link': value['is_default_link'],
        'claims_assignment_number': value['claims_assignment_number'],
        'prefund_initial_delay_date': value['prefund_initial_delay_date'] === null ? null : ((value['prefund_initial_delay_date'] as any)?.toISOString()),
        'card_processing_start_date': value['card_processing_start_date'] === null ? null : ((value['card_processing_start_date'] as any)?.toISOString()),
        'reservation_code': value['reservation_code'],
        'admin_portal_link': value['admin_portal_link'],
        'participant_portal_link': value['participant_portal_link'],
        'is_external_link': value['is_external_link'],
        'external_link': value['external_link'],
        'pricing_consent': value['pricing_consent'],
        'is_organization_orphan': value['is_organization_orphan'],
        'orphan_organization_id': value['orphan_organization_id'],
        'orphan_start_timing_days': value['orphan_start_timing_days'],
        'waiting_for_funds_expiration': value['waiting_for_funds_expiration'],
        'file_location': value['file_location'],
        'allow_manual_contribution': value['allow_manual_contribution'],
        'allow_scheduled_contribution': value['allow_scheduled_contribution'],
        'custom_reporting_field_1_name': value['custom_reporting_field_1_name'],
        'custom_reporting_field_2_name': value['custom_reporting_field_2_name'],
        'custom_reporting_field_3_name': value['custom_reporting_field_3_name'],
        'custom_reporting_field_4_name': value['custom_reporting_field_4_name'],
        'custom_reporting_field_5_name': value['custom_reporting_field_5_name'],
        'is_custom_reporting_field_1_enabled': value['is_custom_reporting_field_1_enabled'],
        'is_custom_reporting_field_2_enabled': value['is_custom_reporting_field_2_enabled'],
        'is_custom_reporting_field_3_enabled': value['is_custom_reporting_field_3_enabled'],
        'is_custom_reporting_field_4_enabled': value['is_custom_reporting_field_4_enabled'],
        'is_custom_reporting_field_5_enabled': value['is_custom_reporting_field_5_enabled'],
        'allow_employees_to_edit_address': value['allow_employees_to_edit_address'],
        'is_claim_offsets_allowed': value['is_claim_offsets_allowed'],
        'claim_offset_logic': value['claim_offset_logic'],
        'allow_prefund': value['allow_prefund'],
        'contribution_push_give_up_days': value['contribution_push_give_up_days'],
        'require_participant_mfa': value['require_participant_mfa'],
        'require_admin_mfa': value['require_admin_mfa'],
        'paper_statement_fees_paid_by': value['paper_statement_fees_paid_by'],
        'paper_statement_fees_amount': value['paper_statement_fees_amount'],
        'admin_chatbot_link': value['admin_chatbot_link'],
        'participant_chatbot_link': value['participant_chatbot_link'],
        'allow_renewals': value['allow_renewals'],
        'working_hours': value['working_hours'],
        'substantiation_rate': value['substantiation_rate'],
        'recurring_card_swipes': value['recurring_card_swipes'],
        'admin_sso_only': value['admin_sso_only'],
        'push_provisioning': value['push_provisioning'],
        'automated_org_lock_enabled': value['automated_org_lock_enabled'],
        'is_sigis_auto_approve_enabled': value['is_sigis_auto_approve_enabled'],
        'external_balance_adjustment_account_method': value['external_balance_adjustment_account_method'],
        'balance_adjustment_hold_period': value['balance_adjustment_hold_period'],
        'balance_adjustment_push_give_up_days': value['balance_adjustment_push_give_up_days'],
        'documents_needed_reminder': value['documents_needed_reminder'],
        'documents_needed_reminder_days': value['documents_needed_reminder_days'],
        'suspend_card': value['suspend_card'],
        'suspend_card_days': value['suspend_card_days'],
        'suspension_threshold': value['suspension_threshold'],
        'suspension_threshold_amount': value['suspension_threshold_amount'],
        'fraud_single_claim_threshold': value['fraud_single_claim_threshold'],
        'fraud_single_claim_threshold_amount': value['fraud_single_claim_threshold_amount'],
        'fraud_daily_threshold': value['fraud_daily_threshold'],
        'fraud_daily_threshold_amount': value['fraud_daily_threshold_amount'],
        'fraud_weekly_threshold': value['fraud_weekly_threshold'],
        'fraud_weekly_threshold_amount': value['fraud_weekly_threshold_amount'],
        'depository_bank_config_type': value['depository_bank_config_type'],
        'zendesk_sso_enabled': value['zendesk_sso_enabled'],
        'days_to_pend_returned_checks': value['days_to_pend_returned_checks'],
        'hsa_custodian_config_id': value['hsa_custodian_config_id'],
    };
}

